import React, { memo } from "react"
import { NextPage } from "next"
import { Meta } from "@/components/Meta/Meta"
import { Note } from "@/components/Note"
import { Notice } from "@/components/Note/Notice"
import { StaticTemplate } from "@/layouts/Static/StaticTemplate"
import { Typography } from "@/ui/Typography/Typography"
import { TITLE_SITE_RU } from "@/utils/constants"

const HelpPage: NextPage = memo(() => {
  return (
    <>
      <Meta
        title={`Помощь - ${TITLE_SITE_RU}`}
        description={`Оформить заказ на нашем сайте легко. Просто добавьте выбранные
            товары в корзину, а затем перейдите на страницу Корзина, проверьте
            правильность заказанных позиций и нажмите кнопку «Оформить заказ»
            или «Быстрый заказ».`}
      />
      <StaticTemplate title={"Как оформить заказ"}>
        <Note>
          <Typography variant={"h2"}>
            Оформить заказ на нашем сайте легко. Просто добавьте выбранные
            товары в корзину, а затем перейдите на страницу Корзина, проверьте
            правильность заказанных позиций и нажмите кнопку «Оформить заказ»
            или «Быстрый заказ».
          </Typography>
        </Note>
        <Note>
          <Typography variant={"h3"}>Покупатель</Typography>
          <Typography>
            Введите данные о себе: ФИО, адрес доставки, номер телефона. В поле
            «Комментарии к заказу» введите сведения, которые могут пригодиться
            курьеру, например: подъезды в доме считаются справа налево.
          </Typography>
        </Note>
        <Note>
          <Typography variant={"h2"}>
            Быстрый заказ или «Купить в 1 клик»
          </Typography>
          <Typography>
            Функция «Быстрый заказ» позволяет покупателю не проходить всю
            процедуру оформления заказа самостоятельно. Вы заполняете форму, и
            через короткое время вам перезвонит менеджер магазина. Он уточнит
            все условия заказа, ответит на вопросы, касающиеся качества товара,
            его особенностей. А также подскажет о вариантах оплаты и доставки.
            По результатам звонка, пользователь либо, получив уточнения,
            самостоятельно оформляет заказ, укомплектовав его необходимыми
            позициями, либо соглашается на оформление в том виде, в котором есть
            сейчас. Получает подтверждение на почту или на мобильный телефон и
            ждёт доставки.
          </Typography>
        </Note>
        <Note
          sideChildren={
            <>
              <Notice title={"Доставка"}>
                В зависимости от места жительства вам предложат варианты
                доставки. Выберите любой удобный способ. Подробнее об условиях
                доставки читайте в разделе «Доставка».
              </Notice>
              <Notice title={"Оплата"}>
                Выберите оптимальный способ оплаты. Подробнее о всех вариантах
                читайте в разделе «Оплата»
              </Notice>
            </>
          }
        >
          <Typography variant={"h2"}>
            Оформление заказа в стандартном режиме
          </Typography>
          <Typography>
            Если вы уверены в выборе, то можете самостоятельно оформить заказ,
            заполнив по этапам всю форму.
          </Typography>
          <Typography variant={"h3"}>Заполнение адреса</Typography>
          <Typography>
            Выберите из списка название вашего региона и населённого пункта.
            Если вы не нашли свой населённый пункт в списке, выберите значение
            «Другое местоположение» и впишите название своего населённого пункта
            в графу «Город». Введите правильный индекс.
          </Typography>
          <Typography variant={"h3"}>Оформление заказа</Typography>
          <Typography>
            Проверьте правильность ввода информации: позиции заказа, выбор
            местоположения, данные о покупателе. Нажмите кнопку «Оформить
            заказ». Наш сервис запоминает данные о пользователе, информацию о
            заказе и в следующий раз предложит вам повторить к вводу данные
            предыдущего заказа. Если условия вам не подходят, выбирайте другие
            варианты.
          </Typography>
        </Note>
      </StaticTemplate>
    </>
  )
})

HelpPage.displayName = "HelpPage"

export default HelpPage
